import React from 'react';
import RewardSections from '../../components/ufo/reward/Index';  // ✅ Fix import

const RewardPage = () => {
  return (
    <>
      <RewardSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default RewardPage;